import type { StarsButtonProps } from '@ps/web-shared-components';
import { StarsButton as Button } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './CasinoFilter.scss';

/*
 * @deprecated
 */
interface Props extends StarsButtonProps {
  active?: boolean;
  hidden?: boolean;
}

const CasinoFilter: React.FC<Props> = ({ active, hidden, ...rest }) => (
  <Button
    className={classNames(styles.filter, active && styles.active, hidden && styles.hidden)}
    variant="filter"
    size="small"
    inverse
    {...rest}
  />
);

export default CasinoFilter;
